// Generated from Swagger on 2025-08-27T14:46:24.209Z
import {
  ApplyManagedImageEditRequestDto,
  FileDetailsResponseDto,
  ManagedImageResponseDto,
  ManagedImageUploadFormData,
} from "./media.interface";

export enum OrganizationBanReason {
  NONE = "NONE",
  PAYMENT_OVERDUE = "PAYMENT_OVERDUE",
  INACTIVE_SUBSCRIPTION = "INACTIVE_SUBSCRIPTION",
  DEACTIVATED_BY_ADMIN = "DEACTIVATED_BY_ADMIN",
}

export interface OrganizationManagedLogoResponseDto {
  _id: string;
  state: ManagedImageResponseDto;
}

export interface OrganizationCustomerDetailsResponseDto {
  name: string;
  logoUrls: string[];
  logos: FileDetailsResponseDto[];
  logoState?: ManagedImageResponseDto;
  logoStates?: OrganizationManagedLogoResponseDto[];
  primaryColor?: string;
  secondaryColor?: string;
  enableMandantFeature?: boolean;
}

export interface ErrorDto {
  message: string;
  error: string;
  statusCode: number;
}

export interface CreateOrganizationRequestDto {
  name: string;
  primaryColor?: string;
  secondaryColor?: string;
}

export interface OrganizationResponseDto {
  _id: string;
  name: string;
  banReason: OrganizationBanReason;
  lastLogin: string;
  organizationAdminId: string;
  logo?: FileDetailsResponseDto;
  createdAt: string;
  updatedAt: string;
}

export interface ObjectId {}

export interface UpdateOrganizationRequestDto {
  name?: string;
  primaryColor?: string;
  secondaryColor?: string;
  enableMandantFeature?: boolean;
}

export enum DepartmentAiCaptionStylePreset {
  CLUB_GERMAN = "CLUB_GERMAN",
  HYPE_GERMAN = "HYPE_GERMAN",
  INTERNATIONAL_ENGLISH = "INTERNATIONAL_ENGLISH",
}

export interface DepartmentAiCaptionSettingsResponseDto {
  department: string;
  enabled: boolean;
  stylePreset: DepartmentAiCaptionStylePreset;
  customInstructions: string;
}

export interface UpdateDepartmentAiCaptionSettingsRequestDto {
  enabled?: boolean;
  stylePreset?: DepartmentAiCaptionStylePreset;
  customInstructions?: string;
}

export interface OrganizationCreationDetailsResponseDto {
  organizationName: string;
}

export type OrganizationsCustomerUploadLogoFormData = ManagedImageUploadFormData;
export type ApplyOrganizationLogoEditRequestDto = ApplyManagedImageEditRequestDto;
export type UOrganizationsCustomerUploadLogoFormData = OrganizationsCustomerUploadLogoFormData;
